"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useShades = void 0;
var _react = require("react");
var _contexts = require("../contexts");
var _mapShades = require("../utils/mapShades");
var _useGetBackgroundColors = require("./useGetBackgroundColors");
const useShades = () => {
  const {
    backgroundColor
  } = (0, _contexts.useQrCodeDialog)();
  const backgroundColors = (0, _useGetBackgroundColors.useGetBackgroundColors)();
  const currentColor = backgroundColors.find(color => color.key === backgroundColor);
  const shades = (0, _react.useMemo)(() => (0, _mapShades.mapShades)(backgroundColors), [backgroundColors]);
  const currentShade = (0, _react.useMemo)(() => shades.find(shade => shade.productCode === currentColor?.key), [shades, currentColor]);
  return {
    shades,
    currentShade,
    currentColor
  };
};
exports.useShades = useShades;
